import { FormDefinitionService } from '@app/core/services/form-definition.service';
import { ChangeDetectionStrategy, Component, inject, signal, computed } from '@angular/core';
import { FieldWrapper, FormlyModule } from '@ngx-formly/core';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { CustomFormlyFieldConfig } from '@app/core/interfaces/formly-forms.interface';
import {MatTabsModule} from '@angular/material/tabs';

interface PageInfo {
  id: string;
  label: string;
  field: CustomFormlyFieldConfig;
  isVisible: boolean;
}

@Component({
  selector: 'formly-field-page',
  templateUrl: './formly-field-page.component.html',
  styleUrls: ['./formly-field-page.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    IonicModule,
    FormlyModule,
    TranslateModule,
    MatTabsModule
  ],
})
export class FormlyFieldPageWrapperComponent extends FieldWrapper {
  private formDefinitionService = inject(FormDefinitionService);

  public hasVisibleChildren(): boolean {
    const flattenedFields = this.formDefinitionService.flattenFormFields(this.field.fieldGroup as CustomFormlyFieldConfig[] || []);
    return flattenedFields.some(f => !f.hide && f.type !== 'HIDDEN');
  }
}
